import React, { useEffect } from 'react';
import JotBar from '../notes/JotBar';
import SongPanel from './SongPanel';
import './SongPanelSheet.css';

/**
 * The Song panel below 1200px (Lesson Dashboard pass 3 D2, 2026-09-28): the
 * SAME SongPanel the desktop column hosts, opened from the tool row's
 * **Lyrics · Tracks · Videos** (each opens it on that mode). It replaces the
 * old full-screen LyricsSheet, which carried lyrics alone.
 *
 *   phone (<768)   full-height sheet, back chevron, and its OWN section
 *                  chips + jot bar pinned below, so a note happens exactly
 *                  when it occurs while reading along (LyricsSheet's rule).
 *   768 to 1199    a 440px side sheet over a scrim; NO jot bar of its own,
 *                  because the page's jot bar is still on screen beside it
 *                  and two jot inputs would be two drafts.
 * `withJot` is decided by the page (its one 768 fork), never here.
 *
 * Opening it on Lyrics fetches the song's lyrics when it has none, as the
 * LyricsSheet did: this sheet is opened deliberately to look at them.
 */
const SongPanelSheet = ({
	song,
	mode,
	onMode,
	facts,
	panes,
	lyrics = null,
	withJot = false,
	sectionChips = null,
	onJot = null,
	onFirstJot = null,
	onClose,
}) => {
	useEffect(() => {
		if (mode === 'lyrics' && lyrics && !lyrics?.lyrics?.text && lyrics.load) lyrics.load();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [song?.id, mode]);

	useEffect(() => {
		const onKey = (e) => {
			if (e.key === 'Escape') onClose();
		};
		document.addEventListener('keydown', onKey);
		return () => document.removeEventListener('keydown', onKey);
	}, [onClose]);

	return (
		<div className="ld-songsheet" role="dialog" aria-modal="true" aria-label="Song panel">
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
			<div className="ld-songsheet__scrim" onClick={onClose} />
			<div className={`ld-songsheet__panel${withJot && sectionChips ? ' has-sections' : ''}${withJot ? ' has-jot' : ''}`}>
				<SongPanel
					song={song}
					mode={mode}
					onMode={onMode}
					facts={facts}
					panes={panes}
					variant="sheet"
					headerExtra={
						<button type="button" className="ld-songsheet__back" aria-label="Back to the lesson" onClick={onClose}>
							<i className="fa-sharp fa-solid fa-chevron-left" aria-hidden="true" />
						</button>
					}
				/>
				{withJot && onJot && (
					<div className="ld-jotbar--fixed ld-songsheet__jot">
						{sectionChips}
						<JotBar onSubmit={onJot} onFirstJot={onFirstJot} />
					</div>
				)}
			</div>
		</div>
	);
};

export default SongPanelSheet;
